exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Account {\n  float: right;\n  display: flex;\n  flex-direction: column;\n  margin: 10px;\n  color: #ccc; }\n\n.account-link {\n  color: #292b2c; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/account.scss
// module id = 402
// module chunks = 0